import { SVGProps } from 'react';

// Icons from the 1browser design (1browser-dashboard/assets): 20px nav-*.svg and 16px ds-*.svg
const NavIcon = ({ viewBox = '0 0 20 20', d, ...props }: SVGProps<SVGSVGElement> & { d: string }) => (
  <svg
    viewBox={viewBox}
    fill='none'
    stroke='currentColor'
    strokeWidth={1.5}
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden
    {...props}
  >
    <path d={d} />
  </svg>
);

export const PricingIcon = (props: SVGProps<SVGSVGElement>) => (
  <NavIcon
    d='M4.375 13.125H8.125M14.375 13.125H15.625M19.375 8.125H0.625M18.125 16.875H1.875C1.185 16.875 0.625 16.315 0.625 15.625V4.375C0.625 3.685 1.185 3.125 1.875 3.125H18.125C18.815 3.125 19.375 3.685 19.375 4.375V15.625C19.375 16.315 18.815 16.875 18.125 16.875Z'
    {...props}
  />
);

export const ApiIcon = (props: SVGProps<SVGSVGElement>) => (
  <NavIcon
    viewBox='0 0 20.25 20.25'
    d='M3.25 10.75C4.63071 10.75 5.75 9.63071 5.75 8.25C5.75 6.86929 4.63071 5.75 3.25 5.75C1.86929 5.75 0.75 6.86929 0.75 8.25C0.75 9.63071 1.86929 10.75 3.25 10.75ZM3.25 10.75V14.5L7 17M10.125 5.75C11.5057 5.75 12.625 4.63071 12.625 3.25C12.625 1.86929 11.5057 0.75 10.125 0.75C8.74429 0.75 7.625 1.86929 7.625 3.25C7.625 4.63071 8.74429 5.75 10.125 5.75ZM10.125 5.75V19.5M17 10.75C18.3807 10.75 19.5 9.63071 19.5 8.25C19.5 6.86929 18.3807 5.75 17 5.75C15.6193 5.75 14.5 6.86929 14.5 8.25C14.5 9.63071 15.6193 10.75 17 10.75ZM17 10.75V14.5L13.25 17'
    {...props}
  />
);

export const UserIcon = (props: SVGProps<SVGSVGElement>) => (
  <NavIcon
    d='M18.0937 18.125C17.7737 13.9312 14.2762 10.625 10 10.625M10 10.625C5.72375 10.625 2.22625 13.9312 1.90625 18.125M10 10.625C12.4162 10.625 14.375 8.66625 14.375 6.25C14.375 3.83375 12.4162 1.875 10 1.875C7.58375 1.875 5.625 3.83375 5.625 6.25C5.625 8.66625 7.58375 10.625 10 10.625Z'
    {...props}
  />
);

export const SupportIcon = (props: SVGProps<SVGSVGElement>) => (
  <NavIcon
    d='M16.875 19.375V14.61C17.8444 13.6799 18.5681 12.524 18.9812 11.2457C19.3944 9.96742 19.4841 8.60662 19.2424 7.28513C19.0007 5.96364 18.4351 4.7227 17.5962 3.6734C16.7573 2.6241 15.6714 1.79918 14.4355 1.27248C13.1996 0.745776 11.8525 0.533735 10.5146 0.655333C9.17667 0.776931 7.8898 1.22837 6.76915 1.96925C5.6485 2.71013 4.72904 3.71732 4.09308 4.90067C3.45712 6.08401 3.1245 7.40659 3.125 8.75V9.375L0.625 13.125L3.125 14.375V17.5C3.125 17.9973 3.32254 18.4742 3.67417 18.8258C4.02581 19.1775 4.50272 19.375 5 19.375H9.375C10.3696 19.375 11.3234 18.9799 12.0267 18.2767C12.7299 17.5734 13.125 16.6196 13.125 15.625V10.625M13.125 10.625C14.5057 10.625 15.625 9.50571 15.625 8.125C15.625 6.74429 14.5057 5.625 13.125 5.625C11.7443 5.625 10.625 6.74429 10.625 8.125C10.625 9.50571 11.7443 10.625 13.125 10.625Z'
    {...props}
  />
);

export const DownloadIcon = (props: SVGProps<SVGSVGElement>) => (
  <NavIcon d='M10 1.875V13.125M10 13.125L5.625 8.75M10 13.125L14.375 8.75M1.875 13.75V16.875C1.875 17.5654 2.43464 18.125 3.125 18.125H16.875C17.5654 18.125 18.125 17.5654 18.125 16.875V13.75' {...props} />
);

const SmallIcon = ({ d, ...props }: SVGProps<SVGSVGElement> & { d: string }) => (
  <NavIcon viewBox='0 0 16 16' strokeWidth={1} d={d} {...props} />
);

export const ChatIcon = (props: SVGProps<SVGSVGElement>) => (
  <SmallIcon
    d='M8.5 7.5V0.5H15.5V5.5H12L8.5 7.5Z M8.5 15.5H0.5V14.5C0.5 12.843 1.843 11.5 3.5 11.5H5.5C7.157 11.5 8.5 12.843 8.5 14.5V15.5Z M4.5 9.5C5.60457 9.5 6.5 8.60457 6.5 7.5C6.5 6.39543 5.60457 5.5 4.5 5.5C3.39543 5.5 2.5 6.39543 2.5 7.5C2.5 8.60457 3.39543 9.5 4.5 9.5Z'
    {...props}
  />
);

export const MailIcon = (props: SVGProps<SVGSVGElement>) => (
  <SmallIcon
    d='M0.5 5L8 9L15.5 5M14 14.5H2C1.602 14.5 1.221 14.342 0.939 14.061C0.658 13.779 0.5 13.398 0.5 13V3C0.5 2.602 0.658 2.221 0.939 1.939C1.221 1.658 1.602 1.5 2 1.5H14C14.398 1.5 14.779 1.658 15.061 1.939C15.342 2.221 15.5 2.602 15.5 3V13C15.5 13.398 15.342 13.779 15.061 14.061C14.779 14.342 14.398 14.5 14 14.5Z'
    {...props}
  />
);

export const ExternalIcon = (props: SVGProps<SVGSVGElement>) => (
  <SmallIcon d='M7 8.961L14.778 1.183M8.415 1.182L14.778 1.183L14.779 7.546' {...props} />
);

export const DocsIcon = (props: SVGProps<SVGSVGElement>) => (
  <SmallIcon d='M14.5 10.5L9.5 15.5H1.5V0.5H14.5V10.5ZM9.5 15.5V10.5H14.5M4.5 4.5H11.5M4.5 7.5H11.5M4.5 10.5H6.5' {...props} />
);

export const CodeIcon = (props: SVGProps<SVGSVGElement>) => (
  <SmallIcon d='M5.5 3L0.5 8L5.5 13M10.5 13L15.5 8L10.5 3' {...props} />
);

export const LogoutIcon = (props: SVGProps<SVGSVGElement>) => (
  <SmallIcon d='M5.5 8.5H15.5M11.5 12.5L15.5 8.5L11.5 4.5M8.5 15.5H1.5C0.948 15.5 0.5 15.052 0.5 14.5V2.5C0.5 1.948 0.948 1.5 1.5 1.5H8.5' {...props} />
);
